import { IS_SAFARI } from './mobileDetect';

const DEFAULT_SCROLL_DURATION = 200;

function scrollPolyfill(scrollElement: HTMLElement, top: number, left: number, duration = DEFAULT_SCROLL_DURATION) {
  const startTop = scrollElement.scrollTop;
  const startLeft = scrollElement.scrollLeft;
  const startTime = performance.now();
  const destinationOffsetToScrollTop = Math.ceil(top);
  const destinationOffsetToScrollLeft = Math.ceil(left);

  function scroll() {
    const now = performance.now();
    const time = Math.min(1, (now - startTime) / duration);

    scrollElement.scrollTop = Math.ceil(time * (destinationOffsetToScrollTop - startTop) + startTop);
    scrollElement.scrollLeft = Math.ceil(time * (destinationOffsetToScrollLeft - startLeft) + startLeft);

    const isComplete =
      scrollElement.scrollTop === destinationOffsetToScrollTop &&
      scrollElement.scrollLeft === destinationOffsetToScrollLeft;

    if (isComplete || now - startTime > duration) {
      return;
    }

    requestAnimationFrame(scroll);
  }

  scroll();
}

export default function scrollTo(
  top = 0,
  left = 0,
  element: Nullable<HTMLElement> = null,
  duration = DEFAULT_SCROLL_DURATION,
) {
  const scrollElement = element || window;

  // @ts-ignore
  if (window.scrollTo) {
    try {
      if (IS_SAFARI && scrollElement !== window) {
        scrollPolyfill(scrollElement as HTMLElement, top, left, duration);
      } else {
        scrollElement.scrollTo({
          top,
          left,
          behavior: 'smooth',
        });
      }
    } catch (e) {
      console.warn(e);
    }
  } else {
    (scrollElement as HTMLElement).scrollTop = top;
    (scrollElement as HTMLElement).scrollLeft = left;
  }
}
